import React, {createContext,  useContext,  useReducer} from "react";
import {reducerFn} from "../reducers/indicatorsReducer";
import {getInitialStateIndicators} from "../reducers/indicatorsReducer/initialValues";

export const IndicatorContext = createContext({});

export const IndicatorProvider = (props) => {

    const [state, dispatch] = useReducer(reducerFn, getInitialStateIndicators());

    function changeTotalIndicators(key, value, lang) {
        dispatch({
            type: lang === 'pt-BR' ? 'add_indicator_pt' : 'add_indicator_en',
            content: {key, value}
        });
    }

    return (
        <IndicatorContext.Provider
            value={{
                indicators: state,
                changeTotalIndicators
            }}>
            {props.children}
        </IndicatorContext.Provider>
    )
}

export const useIndicator = () => useContext(IndicatorContext);
